/*
 * Project: LegalPlace assistant
 * File: src\redux\actions\lperrors.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/
import { store } from '../../globals';


const LP_ERROR_SET = 'LP_ERROR_SET';
const LP_ERROR_UNSET = 'LP_ERROR_UNSET';

/**
 * @description raise the error.
 * @param {LpError} error
 */
function lpSetError(error) {
  return {
    type: LP_ERROR_SET,
    error,
  };
}


/**
 * @description remove the error
 */
function lpUnsetError(component) {
  return {
    type: LP_ERROR_UNSET,
    component,
  };
}

function unsetAfterXSeconds(secs) {
  const dispatch = store.dispatch;
  setTimeout(() => {
    dispatch(lpUnsetError());
  }, secs * 1000);
}

export {
  LP_ERROR_SET,
  LP_ERROR_UNSET,
  lpSetError,
  lpUnsetError,
  unsetAfterXSeconds,
};



// WEBPACK FOOTER //
// ./src/redux/actions/lperrors.js